import { supabase } from './supabaseClient';

export const STICKY_COLORS = ['yellow', 'pink', 'sage'];

function nthWeekdayOfMonth(year, monthIndex, weekday, n) {
  const first = new Date(year, monthIndex, 1);
  const offset = (weekday - first.getDay() + 7) % 7;
  return new Date(year, monthIndex, 1 + offset + (n - 1) * 7);
}

// Anonymous Gregorian algorithm (Meeus/Jones/Butcher).
function easterSunday(year) {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(year, month - 1, day);
}

export function toISODate(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(
    date.getDate()
  ).padStart(2, '0')}`;
}

// Major gifting-relevant holidays for a Jamaican skincare retail business —
// fixed dates plus a handful of floating ones (Easter, Mother's/Father's Day,
// National Heroes Day, Black Friday/Cyber Monday) computed from date rules
// rather than hardcoded, so the calendar stays correct in every year without
// needing yearly upkeep.
export function getGiftingHolidays(year) {
  const thanksgiving = nthWeekdayOfMonth(year, 10, 4, 4); // 4th Thursday of November
  const blackFriday = new Date(year, 10, thanksgiving.getDate() + 1);
  const cyberMonday = new Date(year, 10, thanksgiving.getDate() + 4);

  const holidays = [
    { date: new Date(year, 0, 1), label: "New Year's Day" },
    { date: easterSunday(year), label: 'Easter Sunday' },
    { date: new Date(year, 1, 14), label: "Valentine's Day" },
    { date: nthWeekdayOfMonth(year, 4, 0, 2), label: "Mother's Day" },
    { date: nthWeekdayOfMonth(year, 5, 0, 3), label: "Father's Day" },
    { date: new Date(year, 7, 1), label: 'Emancipation Day' },
    { date: new Date(year, 7, 6), label: 'Independence Day' },
    { date: nthWeekdayOfMonth(year, 9, 1, 3), label: 'National Heroes Day' },
    { date: blackFriday, label: 'Black Friday' },
    { date: cyberMonday, label: 'Cyber Monday' },
    { date: new Date(year, 11, 25), label: 'Christmas Day' },
    { date: new Date(year, 11, 26), label: 'Boxing Day' },
  ];

  return holidays.map((h) => ({ date: toISODate(h.date), label: h.label }));
}

export async function listCalendarNotes(startDate, endDate) {
  const { data, error } = await supabase
    .from('marketing_calendar_notes')
    .select('*, author:profiles(id, display_name, email)')
    .gte('note_date', startDate)
    .lte('note_date', endDate)
    .order('created_at');
  if (error) throw error;
  return data;
}

export async function addCalendarNote({ note_date, body, color, created_by }) {
  const { data, error } = await supabase
    .from('marketing_calendar_notes')
    .insert({ note_date, body, color, created_by })
    .select('*, author:profiles(id, display_name, email)')
    .single();
  if (error) throw error;
  return data;
}

export async function deleteCalendarNote(id) {
  const { error } = await supabase.from('marketing_calendar_notes').delete().eq('id', id);
  if (error) throw error;
}
